import React from 'react'
import { cn } from '@/lib/utils'

// SOURCE: 2026-05-27 feedback — "make 'Boulder · 47th Street' clickable to
// /contact (the page with the actual Google map)." Items can now optionally
// be { label, href }; plain strings still work for the other entries.
export type TrustStripItem = string | { label: string; href: string }

interface TrustStripProps {
  items: TrustStripItem[]
  dark?: boolean
  className?: string
}

function getLabel(item: TrustStripItem): string {
  return typeof item === 'string' ? item : item.label
}

function getHref(item: TrustStripItem): string | undefined {
  return typeof item === 'string' ? undefined : item.href
}

export function TrustStrip({ items, dark = false, className }: TrustStripProps) {
  return (
    <div
      className={cn(
        dark
          ? "bg-primary border-transparent"
          : "bg-[var(--background-warm)] border-t border-b border-border",
        "py-3.5",
        className
      )}
    >
      <div className="container mx-auto px-8">
        <div className="flex items-center justify-center gap-8 flex-wrap text-xs font-semibold tracking-[0.12em] uppercase">
          {items.map((item, i) => {
            const label = getLabel(item)
            const href = getHref(item)
            const itemClass = cn(
              "inline-flex items-center gap-2 whitespace-nowrap",
              dark ? "text-secondary" : "text-primary",
              href && "hover:underline underline-offset-4 transition-colors"
            )
            return (
            <React.Fragment key={i}>
              {href ? (
                <a href={href} className={itemClass}>{label}</a>
              ) : (
                <span className={itemClass}>{label}</span>
              )}
              {i < items.length - 1 && (
                <span
                  className={cn(
                    "hand text-[22px] leading-none tracking-normal normal-case opacity-85",
                    dark ? "text-secondary" : "text-accent"
                  )}
                >
                  &amp;
                </span>
              )}
            </React.Fragment>
            )
          })}
        </div>
      </div>
    </div>
  )
}
